/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceRowUpdateDto
 */
export interface PriceRowUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof PriceRowUpdateDto
     */
    priceUnitId: number;
    /**
     * 
     * @type {number}
     * @memberof PriceRowUpdateDto
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof PriceRowUpdateDto
     */
    rrp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceRowUpdateDto
     */
    lp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceRowUpdateDto
     */
    rm?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceRowUpdateDto
     */
    vat?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PriceRowUpdateDto
     */
    comment?: string | null;
}

/**
 * Check if a given object implements the PriceRowUpdateDto interface.
 */
export function instanceOfPriceRowUpdateDto(value: object): value is PriceRowUpdateDto {
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    return true;
}

export function PriceRowUpdateDtoFromJSON(json: any): PriceRowUpdateDto {
    return PriceRowUpdateDtoFromJSONTyped(json, false);
}

export function PriceRowUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceRowUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceUnitId': json['priceUnitId'],
        'productId': json['productId'],
        'rrp': json['rrp'] == null ? undefined : json['rrp'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'rm': json['rm'] == null ? undefined : json['rm'],
        'vat': json['vat'] == null ? undefined : json['vat'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function PriceRowUpdateDtoToJSON(json: any): PriceRowUpdateDto {
    return PriceRowUpdateDtoToJSONTyped(json, false);
}

export function PriceRowUpdateDtoToJSONTyped(value?: PriceRowUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceUnitId': value['priceUnitId'],
        'productId': value['productId'],
        'rrp': value['rrp'],
        'lp': value['lp'],
        'rm': value['rm'],
        'vat': value['vat'],
        'comment': value['comment'],
    };
}

